import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { isAdminRole, statusOptions } from '../../../utils/mics';
import appActions from '../../../appActions';
import UserForm from './SitesForm';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';

const SitesFilterBar = (props) => {

    const dispatch = useDispatch();

    const storeOtions = useSelector((state) => state.common.storeList);
    const siteGroupOptions = useSelector((state) => state.common.siteGroupList);

    const site = useSelector((state) => state.sites.siteDetails);
    const { userInfo } = props;
    const { userRole } = userInfo;

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (site?.id) {
            setVisible(false);
            dispatch(appActions.SITES_RESET_SUCCESS());
        }
    }, [site]);

    const formik = useFormik({
        initialValues: {
            siteId: '',
            siteType:'',
            siteGroup: [],
            title: '',
            description: '',
            region: '',
            country: '',
            city: '',
            siteLocation: '',
            status: ''
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const data = {
                ...values,
                fetchSiteGroupCode: values?.siteGroup?.join(',') || '',
            };
            const params = data;
            delete params['siteGroup'];
            Object.keys(params).forEach((key) => {
                if (params[key] === '') {
                    delete params[key];
                }
            });
            props.handleFilter(params);
        },
    });

    const handleReset = () => {
        formik.resetForm();
    };

    const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
    };

    return (
        <>
            <Dialog
                header="Create a new site"
                visible={visible}
                style={{ width: '60vw' }}
                onHide={() => setVisible(false)}
            >
                <UserForm />
            </Dialog>

            <div className="flex mb-4 align-items-end">
                <form onSubmit={formik.handleSubmit}>
                    <div className="flex flex-wrap align-items-end gap-10 pb-0">
                        {/* Form Fields */}

                        <div className="form-group">
                            <label htmlFor="siteId" className="flex align-items-center"> Site Id </label>
                            <Dropdown
                                className="w-full"
                                id="siteId"
                                value={formik.values.siteId}
                                options={storeOtions}
                                onChange={(e) => formik.setFieldValue('siteId', e.value)}
                                placeholder="Site Id"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="siteType" className="flex align-items-center"> Site Type </label>
                            <InputText
                                className="w-full"
                                id="siteType"
                                value={formik.values.siteType}
                                onChange={formik.handleChange}
                                placeholder="Site Type"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="siteGroup" className="flex align-items-center"> Site Group </label>
                            {/* <InputText
                                className="w-full"
                                id="siteGroup"
                                value={formik.values.siteGroup}
                                onChange={formik.handleChange}
                                placeholder="Site Group"
                            /> */}
                            <MultiSelect 
                                id="siteGroup"
                                value={formik.values.siteGroup} 
                                onChange={(e) => formik.setFieldValue('siteGroup', e.value)} 
                                options={siteGroupOptions}
                                optionLabel="label" 
                                filter 
                                placeholder="Site Group" 
                                className="w-full"
                                maxSelectedLabels={3}  />
                        </div>

                        <div className="form-group">
                            <label htmlFor="title" className="flex align-items-center"> Title </label>
                            <InputText
                                className="w-full"
                                id="title"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                placeholder="Title"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="emailId" className="flex align-items-center"> Email Id </label>
                            <InputText
                                className="w-full"
                                id="emailId"
                                value={formik.values.emailId}
                                onChange={formik.handleChange}
                                placeholder="Email ID"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="region" className="flex align-items-center"> Region </label>
                            <InputText
                                className="w-full"
                                id="region"
                                value={formik.values.region}
                                onChange={formik.handleChange}
                                placeholder="Region"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="country" className="flex align-items-center"> Country </label>
                            <InputText
                                className="w-full"
                                id="country"
                                value={formik.values.country}
                                onChange={formik.handleChange}
                                placeholder="Country"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="cocityuntry" className="flex align-items-center"> City </label>
                            <InputText
                                className="w-full"
                                id="city"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                placeholder="city"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="status" className="flex align-items-center"> Status </label>
                            <Dropdown
                                className="w-full"
                                id="status"
                                value={formik.values.status}
                                options={statusOptions}
                                optionLabel="name"
                                optionValue='code'
                                onChange={(e) => formik.setFieldValue('status', e.value)}
                                placeholder="Status"
                            />
                        </div>

                       

                        {/* Buttons */}
                        <Button
                            type="submit"
                            icon="pi pi-search"
                            severity="basic"
                        />
                        {!isEmpty(props.filterParams) && (
                            <Button
                                onClick={handleReset}
                                icon="pi pi-times"
                                severity="secondary"
                                aria-label="Cancel"
                            />
                        )}
                    </div>
                </form>
                {isAdminRole(userRole) && (
                    <div className='flex justify-content-end ml-auto' style={{ minWidth: '200px' }}>
                        <div>
                            <Button
                                label="Create a New Site"
                                severity="basic"
                                style={{ marginTop: '36px' }}
                                onClick={() => setVisible(true)}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default SitesFilterBar;
